import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=2a4b9862&scoped=true&"
import script from "./Settings.vue?vue&type=script&lang=js&"
export * from "./Settings.vue?vue&type=script&lang=js&"
import style0 from "./less/profileSettings.less?vue&type=style&index=0&id=2a4b9862&scoped=true&lang=css&"
import style1 from "../../less/_gantt_scroll.less?vue&type=style&index=1&lang=css&"
import style2 from "./Settings.vue?vue&type=style&index=2&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4b9862",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a4b9862')) {
      api.createRecord('2a4b9862', component.options)
    } else {
      api.reload('2a4b9862', component.options)
    }
    module.hot.accept("./Settings.vue?vue&type=template&id=2a4b9862&scoped=true&", function () {
      api.rerender('2a4b9862', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/profileSettings/Settings.vue"
export default component.exports